






import Vue, { PropOptions } from 'vue';
import parts from '@/parts';
import * as TypeVariable from '@/parts/VariableInput.vue';
import TopBar from '@/components/TopBar.vue';
import * as PClass from '@/class';
import * as Models from '@/class/models/views';

const MODE_LOGIN = 'login';
const MODE_SIGNUP = 'signup';
const MODE_REGISTER = 'register';

export default Vue.extend({
  name: 'Top',
  components: {
    ...parts, TopBar,
  },
  props: {
    loginFlag: Boolean,
  },
  data() {
    return {
      mode: '',
      inputData: new Models.CAuth(),
      items: [
        {key: 'ID', name: '', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
        {key: 'Password', name: '', type: TypeVariable.INPUT_TYPE.TEXT, required: true, error: '', max: 99},
      ] as TypeVariable.IVariableInput[],
    };
  },
  computed: {
    MODE_LOGIN(): string { return MODE_LOGIN; },
    MODE_SIGNUP(): string { return MODE_SIGNUP; },
  },
  methods: {
    onClickShowLogin() {
      this.mode = MODE_LOGIN;
    },
    onClickShowSignup() {
      this.mode = MODE_SIGNUP;
    },
    async onClickLogin() {
      // API
    },
    onClickSignup() {
      // API
    },
  },
});
